import ClassName from 'models/classname';
import styles from './TextParagraph.module.scss'
const TextParagraph = ({children, className}) => {
    const textClassName = new ClassName(styles.textParagraph);
    textClassName.addIf(className, className);
    return (
        <p className={textClassName.toString()}>{children}</p>
    )
}

export default TextParagraph